"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceVariationImpressionList = void 0;
exports.priceVariationImpressionList = {
    dayTrader: {
        positiveVariations: [
            { variation: 75.0, impressionNumber: 16 },
            { variation: 65.0, impressionNumber: 15 },
            { variation: 55.0, impressionNumber: 14 },
            { variation: 45.0, impressionNumber: 13 },
            { variation: 30.0, impressionNumber: 12 },
        ],
        negativeVariations: [
            { variation: -70.0, impressionNumber: 9 },
            { variation: -60.0, impressionNumber: 8 },
            { variation: -50.0, impressionNumber: 7 },
            { variation: -40.0, impressionNumber: 6 },
            { variation: -30.0, impressionNumber: 5 },
        ],
    },
    swingTrader: {
        positiveVariations: [
            { variation: 75.0, impressionNumber: 16 },
            { variation: 65.0, impressionNumber: 15 },
            { variation: 45.0, impressionNumber: 13 },
            { variation: 30.0, impressionNumber: 12 },
            { variation: 20.0, impressionNumber: 11 },
            { variation: 15.0, impressionNumber: 10 },
        ],
        negativeVariations: [
            { variation: -70.0, impressionNumber: 9 },
            { variation: -50.0, impressionNumber: 7 },
            { variation: -40.0, impressionNumber: 6 },
            { variation: -30.0, impressionNumber: 5 },
            { variation: -20.0, impressionNumber: 4 },
            { variation: -15.0, impressionNumber: 3 },
        ],
    },
    holder: {
        positiveVariations: [
            { variation: 75.0, impressionNumber: 16 },
            { variation: 65.0, impressionNumber: 15 },
            { variation: 55.0, impressionNumber: 14 },
            { variation: 25.0, impressionNumber: 13 },
            { variation: 15.0, impressionNumber: 12 },
            { variation: 10.0, impressionNumber: 11 },
            { variation: 7.0, impressionNumber: 10 },
        ],
        negativeVariations: [
            { variation: -50.0, impressionNumber: 9 },
            { variation: -25.0, impressionNumber: 6 },
            { variation: -15.0, impressionNumber: 5 },
            { variation: -10.0, impressionNumber: 4 },
            { variation: -7.0, impressionNumber: 3 },
        ],
    },
};
//# sourceMappingURL=price-accumulation.data.js.map